"use strict";
const _ = require('underscore');
const Util = require('common/util');
const DebugContext = require('common/util/debug-context/debug-context');


class CookieStorage {
    write(key, value, path=null, maxAge=null) {
        this.delete(key);
        let str = `${key}=${value}`;
        if (path) {
            str += `;path=${path}`;
        }
        if (maxAge) {
            str += `;max-age=${maxAge}`;
        }

        document.cookie = str;
    }

    read() {
        return document.cookie;
    }

    delete(key) {
        document.cookie = `${key}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    }
}


class DebugContextCookieRepository {
    constructor(keyName='balus_debug_context', storage=null, path='/', maxAge=60*60*24*365) {
        this._keyName = keyName;
        this._storage = storage;
        this._path = path;
        this._maxAge = maxAge;

        if (!this._storage) {
            this._storage = new CookieStorage();
        }
    }

    _fetch() {
        const cookieValues = this._storage.read().split(';');
        const value = _.find(cookieValues, (v) => {
            return v.trim().indexOf(`${this._keyName}=`) == 0;
        });

        if (!value) {
            return null;
        }

        const json = decodeURIComponent(value).split('=', 2)[1];
        return JSON.parse(json);
    }

    fetch() {
        const json = this._fetch();
        if (!json) {
            const token = Util.generateId();
            return new DebugContext(token);
        }

        return DebugContext.loadJSON(json);
    }

    put(debugContext) {
        const json = debugContext.toJSON();
        const encodedValue = encodeURIComponent(JSON.stringify(json));

        this._storage.write(this._keyName, encodedValue, this._path, this._maxAge);
    }

    delete() {
        this._storage.delete(this._keyName);
    }
}

module.exports = DebugContextCookieRepository;



// WEBPACK FOOTER //
// ./common/util/debug-context/debug-context-repository.js